module.exports = __webpack_public_path__ + "img/portfolio1.71d2d808.jpg";